import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CsobFormMetaDataDto, QuestionnaireType } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { AssetQuestionnaireModal } from "../Questionnaires";

import { Grid, Typography } from "@components/base";
import { CardAction } from "@components/common";
import { useCreateCsobForm, useGetCsobFormsMetadata } from "@api";
import { useUserStore } from "@store/user";

const ActionCards: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUserStore();
  const [clientForm, setClientForm] = useState<CsobFormMetaDataDto>();
  const { availableFormsMetadata, isSuccessFormsMetadata } =
    useGetCsobFormsMetadata(user);
  const { createCsobForm, createCsobFormEnabled } = useCreateCsobForm(user);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const openModal = (): void => setModalOpen(true);

  const closeModal = (): void => setModalOpen(false);

  const handleClientFormClick = (): void => {
    if (clientForm) {
      navigate(`/csob/form/${clientForm.formId}`);
    } else {
      createClientForm();
    }
  };

  const createClientForm = (): void =>
    createCsobForm(
      {
        questionnaireType: QuestionnaireType.Client,
        name: "Client form",
        description: "",
        isGroupAsset: false,
        isHedgingAsset: false,
      },
      {
        onSuccess: (res) => {
          navigate(`/csob/form/${res}`);
        },
      },
    );

  useEffect(() => {
    if (availableFormsMetadata && availableFormsMetadata.length > 0) {
      const clientFormData = availableFormsMetadata.find(
        (form) => form.questionnaireType === QuestionnaireType.Client,
      );

      setClientForm(clientFormData);
    }
  }, [availableFormsMetadata]);

  return (
    isSuccessFormsMetadata &&
    createCsobFormEnabled && (
      <Grid container gap={3} height="100%">
        <Grid flex={1} height="100%">
          <CardAction
            title={t("csob.questionnaires.clientForm")}
            text={
              <Typography variant="body2">
                {t("csob.questionnaires.text")}
              </Typography>
            }
            color="violet"
            icon="data-gathering"
            button={{
              text: clientForm
                ? t("csob.questionnaires.openClientForm")
                : t("csob.questionnaires.startClientForm"),
              onClick: handleClientFormClick,
            }}
          />
        </Grid>
        <Grid flex={1} height="100%">
          <CardAction
            title={t("csob.questionnaires.assetTitle")}
            text={
              <Typography variant="body2">
                {t("csob.questionnaires.assetText")}
              </Typography>
            }
            color="teal"
            icon="computer"
            button={{
              text: t("csob.questionnaires.startAssetForm"),
              onClick: openModal,
            }}
          />
        </Grid>
        <AssetQuestionnaireModal isOpen={modalOpen} onClose={closeModal} />
      </Grid>
    )
  );
};

export default ActionCards;
